import React, { Suspense } from "react";

import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

const NavBar = React.lazy(() => import("../../components/navBar"));
const Footer = React.lazy(() => import("../../components/footer"));

const GenAI = () => {
  const navigate = useNavigate();
  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        <NavBar push={navigate} />
        <MsalAuthenticationTemplate>
          <div className="container" style={{ height: "50vh" }}></div>
          <Footer />
          <div
            style={{
              position: "fixed",
              right: "0px",
              height: "85vh",
              width: "100%",
              zIndex: 5000,
              transform: "translateX(50%)",
              bottom: "1%",
              border: "1px solid #000",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
            }}
          >
            <iframe
              src="https://copilotstudio.microsoft.com/environments/b700d30d-5a38-ef40-986f-c7b777535ec1/bots/cr29c_fileInformationAssistant/webchat?__version__=2"
              frameborder="0"
              style={{ width: "50%", height: "100%" }}
              title="genAI"
            ></iframe>
          </div>
        </MsalAuthenticationTemplate>
      </Suspense>
    </>
  );
};

export default GenAI;
